import { Message } from "semantic-ui-react";
import { Link } from "react-router";

const MedUnsuit = (props) => {
	const { Section, enabled, visible, header, msg } = props

	if (!(enabled && visible))
		return null;

	return <Section>
			<br />
			<Message
				error
				visible
				header={header ?? "This medication is unavailable to you through our online prescription service."}
				data-testid = 'label-medication-unavailable' 
				content = {<><br/><p>{msg || <>We suggest you have a <Link className="link" to="/m/pharm/DocCons/DocConsCov">Telehealth Consultation</Link> with one of our doctors to discuss your request.</>}</p></>}
				/>
		</Section>;
};

export default MedUnsuit;
